import { FC, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { AccessControl, DroppableRideWrapper } from "@ryde/controls";
import {
  useNewRideTemplate,
  useRideFormCleanup,
  useRidesNavigation,
} from "@ryde/redux";
import {
  DragTypeEnum,
  DropTypeEnum,
  editFormDataAF,
  IRideDto,
  NAVBAR_DROPPABLE_AREA_ID,
  RideCrudModeKeyTuple,
  useDrawers,
} from "@ryde/shared";

import { LeftNavButtonStyled } from "./left-bar.styled";
import { NavButtonTooltipWrapper } from "./left-bar.tooltip";

export const LeftBarButtonDrop: FC = () => {
  const { t } = useTranslation();
  const { getNewRideTemplate } = useNewRideTemplate();
  const { fullResetPreviousRideEditData } = useRideFormCleanup();
  const tooltip = t(`general.DROP_BUTTON_TOOLTIP`);
  const setRideDto = useSetRecoilState<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );
  const { isRidesEditOrAddRoute } = useRidesNavigation();
  const { openRideEditFormDrawer } = useDrawers();

  const addRide: MouseEventHandler<HTMLElement> = async e => {
    e.preventDefault();
    fullResetPreviousRideEditData();
    const initialRideTemplate = await getNewRideTemplate({});
    setRideDto(initialRideTemplate);
    openRideEditFormDrawer();
  };

  return (
    <AccessControl entity="ride" action="create">
      <LeftNavButtonStyled>
        <DroppableRideWrapper
          id={NAVBAR_DROPPABLE_AREA_ID}
          customClassName="centered"
          disabled={isRidesEditOrAddRoute}
          dropData={{
            accepts: [
              DragTypeEnum.KANBAN_PASSENGER,
              DragTypeEnum.KANBAN_RIDE,
              DragTypeEnum.GRID_RIDE,
              DragTypeEnum.GRID_PASSENGER,
            ],
            typeDrop: DropTypeEnum.NAV_PLUS_BUTTON,
          }}
        >
          <NavButtonTooltipWrapper tooltip={tooltip}>
            <button type="button" onClick={addRide} data-e2e="add_or_drop_ride">
              <SVG_MUI.DropLeftSVG className="svg_normal" />
            </button>
          </NavButtonTooltipWrapper>
        </DroppableRideWrapper>
      </LeftNavButtonStyled>
    </AccessControl>
  );
};
